<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->

<!-- ============================================================== -->
<!-- Start Page Content here -->
<!-- ============================================================== -->
<div class="content-page bg-gray text-dark">
    <div class="content p-1">
        <div class="d-flex">
            <h5 class="px-1 text-capitalize text-dark">Service</h5>
            <div class="ml-auto m-1">
                <div class="float-right">
                    <button type="button" class="btn btn-primary btn-sm" id="addServiceLineMenu" aria-expanded="false"
                        routerLink="add">
                        <span class="dripicons dripicons-plus"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="list-bar">
            <div class="input-group">
                <div class="input-group-append">
                    <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                </div>
                <input autocomplete="off" type="search" class="form-control" id="search" placeholder="Find a ticket...">
            </div>
        </div>
        <div class="row row-cols-1 row-cols-md-3 g-4">
            <div class="col pb-1">
                <div class="card border h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="header-title">All Tickets</h4>
                        <div class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                                aria-expanded="false">
                                <span class="mdi mdi-dots-vertical"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Settings</a>
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Action</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0 mb-3" data-simplebar="init" style="max-height: 315px;">
                        <div class="simplebar-wrapper" style="margin: 0px -24px;">
                            <div class="simplebar-height-auto-observer-wrapper">
                                <div class="simplebar-height-auto-observer"></div>
                            </div>
                            <div class="simplebar-mask">
                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                        aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px 24px;">
                                            <table class="table table-sm text-nowrap table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Status</th>
                                                        <th>Date</th>
                                                        <th>Last 6 VIN</th>
                                                        <th>Name</th>
                                                        <th>Cell</th>
                                                        <th>Vehicle</th>
                                                        <th>Desc.</th>
                                                        <!-- <th>Total Cost</th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (ticket of tickets; track ticket) {
                                                    <tr>
                                                        <td><a [routerLink]="ticket.id">{{ticket.id}}</a></td>
                                                        <td>{{ticket.status}}</td>
                                                        <td>{{ticket.serviceDate | date: "shortDate" }}</td>
                                                        <td>@if (ticket.vehicle) {
                                                            <span>{{formatLastVINDigits(ticket.vehicle.vinNumber,6)}}</span>
                                                            }
                                                        </td>
                                                        <td>@if (ticket.contact) {
                                                            <a [routerLink]="ticket.id">{{ticket.contact.lastName}},
                                                                {{ticket.contact.firstName}}</a>
                                                            }
                                                        </td>
                                                        <td>{{formatPhoneNumber(ticket.cellPhone)}}</td>
                                                        <td>@if (ticket.vehicle) {
                                                            <span>{{ticket.vehicle.make}} {{ticket.vehicle.model}}
                                                                {{ticket.vehicle.modelYear}}</span>
                                                            }
                                                        </td>
                                                        <td>{{ticket.description}}</td>
                                                        <!-- <td>{{ticket.description}}</td> -->
                                                    </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="simplebar-placeholder" style="width: auto; height: 331px;"></div>
                        </div>
                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                        </div>
                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                            <div class="simplebar-scrollbar"
                                style="height: 299px; transform: translate3d(0px, 16px, 0px); display: block;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col pb-1">
                <div class="card border h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="header-title">Recently Updated Tickets</h4>
                        <div class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                                aria-expanded="false">
                                <span class="mdi mdi-dots-vertical"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Settings</a>
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Action</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0 mb-3" data-simplebar="init" style="max-height: 315px;">
                        <div class="simplebar-wrapper" style="margin: 0px -24px;">
                            <div class="simplebar-height-auto-observer-wrapper">
                                <div class="simplebar-height-auto-observer"></div>
                            </div>
                            <div class="simplebar-mask">
                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                        aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px 24px;">
                                            <table class="table table-sm text-nowrap table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Name</th>
                                                        <th>Cell</th>
                                                        <th>Vehicle</th>
                                                        <th>Desc.</th>
                                                        <th>Total Cost</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>10/1/23</td>
                                                        <td><a routerLink="add">Sabra, Diane</a></td>
                                                        <td>832-567-4005</td>
                                                        <td>Black Honda CR-V 2017</td>
                                                        <td>Engine light</td>
                                                        <td>395.75</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10/1/23</td>
                                                        <td><a routerLink="add">Sabra, Ramzi</a></td>
                                                        <td>832-323-4005</td>
                                                        <td>Black GMC Yukon 2005</td>
                                                        <td>Engine light</td>
                                                        <td>341.75</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10/1/23</td>
                                                        <td><a routerLink="add">Sabra, Magida</a></td>
                                                        <td>832-567-5432</td>
                                                        <td>Maroon Lexus GX150 2018</td>
                                                        <td>Engine light</td>
                                                        <td>766.75</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10/1/23</td>
                                                        <td><a routerLink="add">Miller, Bill</a></td>
                                                        <td>832-123-4005</td>
                                                        <td>Blue Lexus 2015</td>
                                                        <td>Engine light</td>
                                                        <td>456.75</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10/1/23</td>
                                                        <td><a routerLink="add">Miller, Jill</a></td>
                                                        <td>832-567-7533</td>
                                                        <td></td>
                                                        <td>Engine light</td>
                                                        <td>342.75</td>
                                                    </tr>
                                                    <tr>
                                                        <td>10/1/23</td>
                                                        <td><a routerLink="add">Watts, Stephen</a></td>
                                                        <td>832-443-4434</td>
                                                        <td>Black Honda CR-V 2022</td>
                                                        <td>Brakes</td>
                                                        <td>300.75</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="simplebar-placeholder" style="width: auto; height: 331px;"></div>
                        </div>
                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                        </div>
                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                            <div class="simplebar-scrollbar"
                                style="height: 299px; transform: translate3d(0px, 16px, 0px); display: block;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col pb-1">
                <div class="card border h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="header-title row align-items-center">Tickets
                            <select class="custom-select custom-select-sm form-control form-control-sm col-3 py-1">
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                            </select>Month Old
                        </h4>
                        <div class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                                aria-expanded="false">
                                <span class="mdi mdi-dots-vertical"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Settings</a>
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Action</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0 mb-3" data-simplebar="init" style="max-height: 315px;">
                        <div class="simplebar-wrapper" style="margin: 0px -24px;">
                            <div class="simplebar-height-auto-observer-wrapper">
                                <div class="simplebar-height-auto-observer"></div>
                            </div>
                            <div class="simplebar-mask">
                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                        aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px 24px;">
                                            <table class="table table-sm text-nowrap table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>Service Date</th>
                                                        <th>Full Name</th>
                                                        <th>Cell Number</th>
                                                        <th>Vehicle</th>
                                                        <th>Description</th>
                                                        <th>Total Cost</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>9/1/23</td>
                                                        <td><a routerLink="add">Shokralla, Maged</a></td>
                                                        <td>832-745-8954</td>
                                                        <td>Black Toyota Camry 2007</td>
                                                        <td>Engine light</td>
                                                        <td>395.75</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="simplebar-placeholder" style="width: auto; height: 331px;"></div>
                        </div>
                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                        </div>
                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                            <div class="simplebar-scrollbar"
                                style="height: 299px; transform: translate3d(0px, 16px, 0px); display: block;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col pb-1">
                <div class="card border h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="header-title">Transactions</h4>
                        <div class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                                aria-expanded="false">
                                <span class="mdi mdi-dots-vertical"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Settings</a>
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Action</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0 mb-3" data-simplebar="init" style="max-height: 315px;">
                        <div class="simplebar-wrapper" style="margin: 0px -24px;">
                            <div class="simplebar-height-auto-observer-wrapper">
                                <div class="simplebar-height-auto-observer"></div>
                            </div>
                            <div class="simplebar-mask">
                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                        aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px 24px;">
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-up text-danger font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" routerLink="add" class="text-body">Payment
                                                        received for Ticket
                                                        <a href="javascript:;">
                                                            1203</a></a>
                                                    <p class="mb-0 text-muted"><small>Today by Rahma, Masar</small></p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-success fw-bold pe-2">$489.30</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-down text-success font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" routerLink="add" class="text-body">Payment
                                                        received
                                                        for Ticket <a href="javascript:;">2912</a></a>
                                                    <p class="mb-0 text-muted"><small>Yesterday by Rahma, Masar</small>
                                                    </p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-success fw-bold pe-2">$1578.54</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-up text-danger font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" routerLink="add" class="text-body">Purchased
                                                        a new Part</a>
                                                    <p class="mb-0 text-muted"><small>09 Sep 2018 by Rahma,
                                                            Masar</small></p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-danger fw-bold pe-2">$185.14</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-down text-success font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" class="text-body">Money received from
                                                        paypal for Ticket <a href="javascript:;"
                                                            routerLink="add">3922</a></a>
                                                    <p class="mb-0 text-muted"><small>28 Aug 2018 by Rahma,
                                                            Masar</small></p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-success fw-bold pe-2">$684.45</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-up text-danger font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" class="text-body">Payment received for Ticket
                                                        <a href="javascript:;" routerLink="add">
                                                            1203</a></a>
                                                    <p class="mb-0 text-muted"><small>Today by Rahma, Masar</small></p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-success fw-bold pe-2">$489.30</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-down text-success font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" class="text-body">Payment received
                                                        for Ticket <a href="javascript:;" routerLink="add">2912</a></a>
                                                    <p class="mb-0 text-muted"><small>Yesterday by Rahma, Masar</small>
                                                    </p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-success fw-bold pe-2">$1578.54</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-up text-danger font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" routerLink="add" class="text-body">Purchased
                                                        a new
                                                        Part</a>
                                                    <p class="mb-0 text-muted"><small>09 Sep 2018 by Rahma,
                                                            Masar</small></p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-danger fw-bold pe-2">$185.14</span>
                                                </div>
                                            </div>
                                            <div class="row py-1 align-items-center">
                                                <div class="col-auto">
                                                    <span class="mdi mdi-arrow-collapse-down text-success font-18"></span>
                                                </div>
                                                <div class="col ps-0">
                                                    <a href="javascript:;" routerLink="add" class="text-body">Money
                                                        received from
                                                        paypal for Ticket<a href="javascript:;"> 3922</a></a>
                                                    <p class="mb-0 text-muted"><small>28 Aug 2018 by Rahma,
                                                            Masar</small></p>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="text-success fw-bold pe-2">$684.45</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="simplebar-placeholder" style="width: auto; height: 463px;"></div>
                        </div>
                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                        </div>
                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                            <div class="simplebar-scrollbar"
                                style="height: 214px; transform: translate3d(0px, 0px, 0px); display: block;"></div>
                        </div>
                    </div> <!-- end slimscroll -->
                </div>
            </div>
            <div class="col pb-1">
                <div class="card border h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="header-title">Recent Activity</h4>
                        <div class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                                aria-expanded="false">
                                <span class="mdi mdi-dots-vertical"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Settings</a>
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Action</a>
                            </div>
                        </div>
                    </div>

                    <div class="card-body py-0 mb-3" data-simplebar="init" style="max-height: 315px;">
                        <div class="simplebar-wrapper" style="margin: 0px -24px;">
                            <div class="simplebar-height-auto-observer-wrapper">
                                <div class="simplebar-height-auto-observer"></div>
                            </div>
                            <div class="simplebar-mask">
                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                        aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px 24px;">
                                            <div class="timeline-alt py-0">
                                                <div class="timeline-item">
                                                    <span
                                                        class="mdi mdi-upload bg-info-lighten text-info timeline-icon"></span>
                                                    <div class="timeline-item-info">
                                                        <a href="javascript:;" routerLink="add"
                                                            class="text-info fw-bold mb-1 d-block">Shahad created a
                                                            ticket 3434</a>
                                                        <small>Total Cost: $456.39, Engine is out</small>
                                                        <p class="mb-0 pb-2">
                                                            <small class="text-muted">5 minutes ago</small>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="timeline-item">
                                                    <span
                                                        class="mdi mdi-airplane bg-primary-lighten text-primary timeline-icon"></span>
                                                    <div class="timeline-item-info">
                                                        <a href="javascript:;" routerLink="add"
                                                            class="text-primary fw-bold mb-1 d-block">Masar cancelled
                                                            ticket 1293</a>
                                                        <small>Customer doesn't want to pay
                                                        </small>
                                                        <p class="mb-0 pb-2">
                                                            <small class="text-muted">30 minutes ago</small>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="timeline-item">
                                                    <span
                                                        class="mdi mdi-microphone bg-info-lighten text-info timeline-icon"></span>
                                                    <div class="timeline-item-info">
                                                        <a href="javascript:;" routerLink="add"
                                                            class="text-info fw-bold mb-1 d-block">Shahad added a part
                                                            to ticket 3492</a>
                                                        <small>Part #: 239238 for $45.40
                                                        </small>
                                                        <p class="mb-0 pb-2">
                                                            <small class="text-muted">2 hours ago</small>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="timeline-item">
                                                    <span
                                                        class="mdi mdi-upload bg-primary-lighten text-primary timeline-icon"></span>
                                                    <div class="timeline-item-info">
                                                        <a href="javascript:;" routerLink="add"
                                                            class="text-primary fw-bold mb-1 d-block">Shahad completed
                                                            the work for ticket 3932</a>
                                                        <small>Labor Hours: 2 for $45.32
                                                        </small>
                                                        <p class="mb-0 pb-2">
                                                            <small class="text-muted">14 hours ago</small>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- end timeline -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="simplebar-placeholder" style="width: auto; height: 331px;"></div>
                        </div>
                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                        </div>
                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                            <div class="simplebar-scrollbar"
                                style="height: 299px; transform: translate3d(0px, 16px, 0px); display: block;"></div>
                        </div>
                    </div> <!-- end slimscroll -->
                </div>
            </div>
            <div class="col pb-1">
                <div class="card border h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="header-title">Ticket per Servicer</h4>
                        <div class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                                aria-expanded="false">
                                <span class="mdi mdi-dots-vertical"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Settings</a>
                                <!-- item-->
                                <a href="javascript:;" class="dropdown-item">Action</a>
                            </div>
                        </div>
                    </div>

                    <div class="card-body py-0 mb-3" data-simplebar="init" style="max-height: 315px;">
                        <div class="simplebar-wrapper" style="margin: 0px -24px;">
                            <div class="simplebar-height-auto-observer-wrapper">
                                <div class="simplebar-height-auto-observer"></div>
                            </div>
                            <div class="simplebar-mask">
                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                        aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px 24px;">
                                            <ul id="snapshot-items">
                                                <li>
                                                    <p>Masar</p>
                                                    <p class="float-right">15</p>
                                                </li>
                                                <li>
                                                    <p>Shahad</p>
                                                    <p class="float-right">15</p>
                                                </li>
                                                <li>
                                                    <p>Santiago</p>
                                                    <p class="float-right">15</p>
                                                </li>
                                                <li>
                                                    <p>Stephen</p>
                                                    <p class="float-right">15</p>
                                                </li>
                                                <li>
                                                    <p>Sergio</p>
                                                    <p class="float-right">15</p>
                                                </li>
                                                <li>
                                                    <p>Ken</p>
                                                    <p class="float-right">15</p>
                                                </li>
                                            </ul>
                                            <!-- end timeline -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="simplebar-placeholder" style="width: auto; height: 331px;"></div>
                        </div>
                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                        </div>
                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                            <div class="simplebar-scrollbar"
                                style="height: 299px; transform: translate3d(0px, 16px, 0px); display: block;"></div>
                        </div>
                    </div> <!-- end slimscroll -->
                </div>
            </div>
        </div>
    </div>
</div>